import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0fd2b320&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0fd2b320&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd2b320",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fd2b320')) {
      api.createRecord('0fd2b320', component.options)
    } else {
      api.reload('0fd2b320', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0fd2b320&scoped=true", function () {
      api.rerender('0fd2b320', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/deyu/index.vue"
export default component.exports